import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import getSearchParam from '@newswebsiteapp/shared/lib/getSearchParam'

controllerLoadedObservableFactory('publication_show_page').subscribe(
  async () => {
    const scrollToParagraph = getSearchParam(
      'scroll_to_paragraph',
      window.location.href,
    )

    const scrollToParagraph_ = Number(scrollToParagraph)

    if (!scrollToParagraph_) {
      return
    }

    await waitForMainImageToLoad()
    await sleep(500)

    const paragraph$ = $('.publication-content__content-block').find('p')[
      scrollToParagraph_ - 1
    ]

    $('html, body').scrollTo(paragraph$, 500, {
      axis: 'y',
      over: 0.5,
      offset: -$(window).height() / 2,
    })
  },
)

function sleep(milliseconds) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

function waitForMainImageToLoad() {
  return new Promise((resolve, reject) => {
    const img$ = $('.main-image')

    if (img$.length === 0) {
      resolve()
      return
    }

    img$.each(function () {
      if (this.complete) {
        resolve()
      }
    })

    img$.on('load', resolve).on('error', resolve)
  })
}
